import * as angular from 'angular';

import { AlarmsHeatMapConfiguration } from './alarmsHeatMap.configuration';
import { Helper } from '../../common';
import { WidgetBase } from '../models';
import { alarmsHeatMapWidgetDefinition as definition, alarmsHeatMapWidgetDefinition } from './alarmsHeatMap.definition';

export class AlarmsHeatMapWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: AlarmsHeatMapConfiguration;
    exportFormats = ['csv'];
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = false;
    name = alarmsHeatMapWidgetDefinition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;
    
    exportToCsv: () => angular.IPromise<void>;

    constructor() {
        super();
        this.guid = Helper.getGuid();
        this.configuration = {
            coloringScale: 10,
            dashboardGuid: '',
            groupGuids: [],
            groupTypes: [],
            includeChildren: false,
            isBoundToGroup: false,
            isChildrenStacked: true,
            isColoring: true,
            severities: []
        };
    }
}